var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueMultiselectComponent',{staticClass:"bg-white rounded",attrs:{"options":_vm.data,"placeholder":_vm.placeholder},model:{value:(_vm.localSelected),callback:function ($$v) {_vm.localSelected=$$v},expression:"localSelected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }